import React, { useEffect, useState } from 'react';
import Default from './Default';
import { authenticatedUserAddress, getUserData, isUserSignedIn } from '../../services/auth';
import { clientNetwork, deruptPfp } from '../../lib/constants';
import axios from 'axios';
import PngAvatar from './PngAvatar';
import NftAvatar from './NftAvatar';
import { callReadOnlyFunction, cvToString, cvToValue, uintCV } from '@stacks/transactions';
import { getUserLoadOutUri } from '../../services/stacks';

const appOrigin = window.location.origin;

const Avatar = ({
    authorPrincipal,
    loadOutUri,
    userSettings,
    profile,
    setErrorMsg,
    setOpenSnackBar,
    setShowBannerUpload,
    setShowUserContractDeployModal,
    setShowAdvisoryModal,
    setShowWoopsModal,
    userContractStatus,
    setShowAvatarConfigModal,
    loadOutData,
    setLoadOutData
}) => {
    const [avatarType, setAvatarType] = useState("default");
    const authUser = authenticatedUserAddress({ network: clientNetwork });

    function validate(open, value) {
        console.log({ userContractStatus });
        switch (userContractStatus) {
            case true:
                open(value);
                break;
            case false:
            case 'success':
            case 'mempool':
            case 'abort_by_post_condition':
            case 'abort_by_response':
                setShowUserContractDeployModal(true);
                break;
            case 'updateNeeded':
                setShowAdvisoryModal(true);
                break;
            default:
                if (isUserSignedIn()) {
                    setShowUserContractDeployModal(true);
                } else {
                    setShowWoopsModal(true);
                }
                break;
        }
    }

    function handleAvatarConfig() {
        if (authorPrincipal !== authUser) return;
        if (loadOutUri === undefined) {
            console.log('F1');
            validate(setShowUserContractDeployModal, true);
        } else if ((loadOutUri === 'default') || (loadOutUri !== getUserData()?.profile?.apps[appOrigin])) {
            console.log('F2', (loadOutUri === 'default') || (loadOutUri !== getUserData()?.profile?.apps[appOrigin]));
            console.log('F2', (loadOutUri === 'default'), (loadOutUri !== getUserData()?.profile?.apps[appOrigin]));
            setShowBannerUpload(true);
        } else {
            console.log('F3');
            validate(setShowAvatarConfigModal, true);
        }
    }

    useEffect(() => {
        async function initAvatarComponent() {
            let uri;
            if (profile) {
                uri = loadOutUri + deruptPfp;
            } else {
                const loadoutpath = await getUserLoadOutUri();
                if (!loadoutpath) return
                uri = loadoutpath + deruptPfp;
            }
            console.log({ uri });
            try {
                const loadOutMeta = (await axios.get(uri)).data;
                if (loadOutMeta?.type) {
                    const { type } = loadOutMeta;
                    setAvatarType(type);
                    setLoadOutData(loadOutMeta);
                }
            } catch (e) { console.log({ e }); }
        }
        initAvatarComponent();
        console.log({ userContractStatus });
    }, [])

    useEffect(() => {
        async function verifyNftId() {
            const { nft: { id, contract } } = loadOutData;
            const isOwner = cvToValue(await callReadOnlyFunction({
                contractAddress: contract.split('.')[0],
                contractName: contract.split('.')[1].split('::')[0],
                functionName: 'get-owner',
                functionArgs: [uintCV(id)],
                senderAddress: authUser
            }))?.value?.value;
            if (isOwner !== authUser) setAvatarType('default');
        }
        if (loadOutData?.type === "nft") {
            verifyNftId();
        }
        console.log({ loadOutData });
    }, [loadOutData])

    return (
        <div onClick={profile ? handleAvatarConfig : null} className='avatar-component'>
            {avatarType === 'nft' && <NftAvatar url={loadOutData[avatarType]?.img} />}
            {avatarType === 'custom' && <PngAvatar authorPrincipal={authorPrincipal} url={loadOutData[avatarType]?.img} />}
            {avatarType === "default" && <Default authorPrincipal={authorPrincipal} />}
        </div>
    );
};

export default Avatar;